import { createFileRoute } from '@tanstack/react-router';
import { notificationsSearchSchema } from '@/features/activity/notifications/api';
import { NotificationsPage } from '@/features/activity/notifications/notifications-page';

// S20 · Notifications: the filters (state, channel, kind) live in the URL.
export const Route = createFileRoute('/_app/activity/notifications')({
  validateSearch: notificationsSearchSchema,
  component: NotificationsPage,
});
